export default __webpack_public_path__ + "static/river-level-4424edd238e0ea43e7a18c096e7cac47.png";